import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type RocketIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const RocketIllustration = ({ title, desc, ...props }: RocketIllustrationProps) => (
  <BaseIllustration width="122" height="122" viewBox="0 0 122 122" {...props}>
    {title && <title>{title}</title>}
    {desc && <desc>{desc}</desc>}
    <path
      d="M63.1526 22.0457C48.0165 15.527 28.6133 19.5455 14.3633 37.6818L31.8104 55.1341"
      fill="none"
      strokeWidth="5.99999"
      strokeMiterlimit="10"
    />
    <path
      d="M99.9556 58.8466C106.474 73.9826 102.456 93.3859 84.3195 107.636L66.8672 90.1887"
      fill="none"
      strokeWidth="5.99999"
      strokeMiterlimit="10"
    />
    <path
      d="M53.2265 97.2725L24.7266 68.7726C24.7266 68.7726 47.7701 7.66354 117.999 4C114.03 73.9233 53.2265 97.2725 53.2265 97.2725Z"
      fill="none"
      strokeWidth="5.99999"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M75.8968 54.6842C81.6205 54.6842 86.2604 50.0443 86.2604 44.3206C86.2604 38.5969 81.6205 33.957 75.8968 33.957C70.1732 33.957 65.5332 38.5969 65.5332 44.3206C65.5332 50.0443 70.1732 54.6842 75.8968 54.6842Z"
      fill="none"
      strokeWidth="5.99999"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.384 93.2931C12.8138 90.8634 16.1092 89.4984 19.5454 89.4984C22.9816 89.4984 26.2771 90.8634 28.7069 93.2931C31.1366 95.7229 32.5016 99.0184 32.5016 102.455C32.5016 105.891 31.1366 109.186 28.7069 111.616C23.6468 116.673 4 118 4 118C4 118 5.32654 98.3532 10.384 93.2931Z"
      fill="none"
      strokeWidth="5.99999"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </BaseIllustration>
);

RocketIllustration.displayName = 'RocketIllustration';
